<mat-toolbar>
	Channel Details
	<span fxFlex></span>
	<div class="action-buttons">
		<button [disableRipple]="true" mat-icon-button [matMenuTriggerFor]="menu">
			<mat-icon>more_vert</mat-icon>
		</button>

		<mat-menu #menu="matMenu">
			<button [disableRipple]="true" mat-menu-item onClick="">Edit</button>
			<button [disableRipple]="true" mat-menu-item onClick="">Share</button>
			<button [disableRipple]="true" mat-menu-item onClick="">Copy</button>
			<button [disableRipple]="true" mat-menu-item onClick="">Archive</button>
			<button [disableRipple]="true" mat-menu-item onClick="">Delete</button>
		</mat-menu>
		<button [disableRipple]="true" mat-icon-button (click)="drawer.close()">
			<mat-icon>cancel</mat-icon>
		</button>
	</div>
</mat-toolbar>
<div class="drawer-content">
	<div class="detail-section">
		<div class="internal-section">
			<div class="__header">
				<h4>Channel Image</h4>
			</div>
			<div class="__content">
				<div class="channel-image">
					<img [src]="channelImageURL" alt="" />
				</div>
			</div>
		</div>
		<div class="internal-section mt-[25px]">
			<div *ngFor="let item of channelDetail | keyvalue">
				<div class="detail-card">
					<div class="__header">
						<h4>{{ item.key }}</h4>
					</div>
					<div class="__content">
						<p>{{ item.value }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
